module.exports = __webpack_public_path__ + "img/gis2_on.197b23b2.png";